export const insuranceContent = [
  {
    heroTitle: "Professional Insurance Contractors",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "A Decade of Servicing Insurance Clientele",
    introText: `Our aim is and has always been to offer the very best in support and assistance for all domestic building maintenance and we have the privilege of working alongside some of the biggest names in national insurance across the U.K.`,
  },
  {
    contLeftTitle: "Highly Trained Industry Experts",
    contLeftText: `Our highly trained and professional engineers can be trusted to carry out all plumbing and gas work on your behalf to the very highest standard. `,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643110467/AquaHeat/new%20images/Screenshot_2022-01-25_at_11.32.41_grjyuy.webp`,
  },
  {
    contRightTitle: "We're Registered and Accredited",
    contRightText: `Aqua Heat is registered and accredited with ISO / Safe Contractor / NICEIC / GAS Safe and CHAS. Our insurances include Public Liability and Professional Indemnity and Employers Liability.`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643110562/AquaHeat/new%20images/Screenshot_2022-01-25_at_11.31.50_msgsx0.webp`,
  },
  {
    callToActionTitle: "For More Information Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
